import * as Sentry from "@sentry/react";
import axios from "axios";

Sentry.init({
    dsn: "https://f3500790bbb1122978b4e3cadc7f7024@o4511385627918336.ingest.us.sentry.io/4511487360958464",
    environment: process.env.NODE_ENV,
    enabled: process.env.NODE_ENV !== "development",
    tracesSampleRate: 0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: false,
    integrations: [
        Sentry.replayIntegration({
            maskAllText: false,
            maskAllInputs: false,
            blockAllMedia: false,
        }),
    ],
});

export function applySentryUser(user: any) {
    if (!user) {
        Sentry.setUser(null);
        return;
    }
    Sentry.setUser({
        id: user.seq != null ? String(user.seq) : undefined,
        username: user.userId,
    });
    if (user.auth) Sentry.setTag("user.auth", user.auth);
    if (user.companyName) Sentry.setTag("user.company", user.companyName);
}

(function applySentryUserFromStorage() {
    try {
        const raw = sessionStorage.getItem("USER_SESSION");
        if (!raw) {
            Sentry.setUser(null);
            return;
        }
        applySentryUser(JSON.parse(raw));
    } catch {
        Sentry.setUser(null);
    }
})();

axios.defaults.timeout = 60000;

axios.interceptors.response.use(
    (response) => response,
    (error: any) => {
        if (axios.isCancel(error)) return Promise.reject(error);

        const status = error.response?.status;
        const code = error.code;
        const cfg = error.config;
        const url = cfg?.url;
        const method = (cfg?.method || "get").toUpperCase();

        if (status === 401 || status === 403) {
            if (status === 401 && window.location.pathname !== "/") {
                sessionStorage.removeItem("USER_SESSION");
                Sentry.setUser(null);
                sessionStorage.setItem("FLASH_SNACK", "세션이 만료되었습니다. 다시 로그인해 주세요.");
                window.location.replace("/");
                return new Promise(() => {});
            }
            return Promise.reject(error);
        }

        let category: string | null = null;
        let level: Sentry.SeverityLevel = "error";
        let message = "";

        if (code === "ECONNABORTED" || /timeout/i.test(error.message)) {
            category = "응답 지연 (타임아웃)";
            level = "warning";
            message = `[axios timeout] ${method} ${url} (60s 초과)`;
        } else if (code === "ERR_NETWORK" || !error.response) {
            window.dispatchEvent(new CustomEvent("app:network-error"));
            return Promise.reject(error);
        } else if (status && status >= 500) {
            category = "서버 통신 실패 (5xx)";
            level = "error";
            message = `[axios ${status}] ${method} ${url}`;
        } else if (status && status >= 400) {
            category = "잘못된 요청 데이터 (4xx)";
            level = "warning";
            message = `[axios ${status}] ${method} ${url}`;
        }

        if (category) {
            Sentry.withScope((scope) => {
                scope.setTag("error.category", category!);
                scope.setLevel(level);
                scope.setExtra("axios", {
                    url,
                    method,
                    status,
                    code,
                    response: typeof error.response?.data === "string"
                        ? error.response.data.slice(0, 1000)
                        : JSON.stringify(error.response?.data ?? null).slice(0, 1000),
                });
                Sentry.captureMessage(message);
            });
        }

        return Promise.reject(error);
    }
);
